import { render, staticRenderFns } from "./LastUpdateInfo.vue?vue&type=template&id=77b3df34"
import script from "./LastUpdateInfo.vue?vue&type=script&lang=js"
export * from "./LastUpdateInfo.vue?vue&type=script&lang=js"
import style0 from "./LastUpdateInfo.vue?vue&type=style&index=0&id=77b3df34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports